module.exports = __webpack_public_path__ + "public/img/Menyusun Surat Bisnis Dalam Bahasa Inggris Bagi Calon Sekretaris_1.d8bb7b23.png";